import { useEditor } from '@tiptap/vue-3';
import { useRichTextEditorExtensions } from './useExtensions';

export function useRichTextEditor({
  editable,
  model,
  onUpdate,
  onSelectionUpdate = () => {},
  onFocus = (e, view) => {},
  onBlur = (e, view) => {},
  onEnter = (e, view) => {},
  onPaste,
  keyboard = true,
  extensions = {},
}) {
  return useEditor({
    editable: editable,
    content: model,
    //@ts-ignore
    keyboard,
    onUpdate,
    onSelectionUpdate,
    editorProps: {
      handleDOMEvents: {
        drop: (view, e) => {
          e.preventDefault();
        },
        paste: (view, e) => {
          if (onPaste) {
            onPaste(e, view);
          }
        },
        keydown: (view, e) => {
          if (!keyboard) {
            e.preventDefault();
          }
          if (e.key === 'Enter' && onEnter) {
            //@ts-ignore
            const result = onEnter(e, view) ?? true;
            if (!result) {
              e.preventDefault(); // ✅ Redundant but safe
              return true; // ✅ Tells ProseMirror it's handled
            }
          }
        },
        click: (view, e) => {
          //@ts-ignore
          const link = e.target.closest('a');
          if (link) {
            e.preventDefault();
            e.stopPropagation();
            window.open(link.href, '_blank');
          }
        },
        blur: (view, e) => {
          if (onBlur) {
            onBlur(e, view);
          }
        },
        focus: (view, e) => {
          if (onFocus) {
            onFocus(e, view);
          }
        },
      },
    },
    extensions: useRichTextEditorExtensions(extensions),
  });
}
